module.exports = __webpack_public_path__ + "img/chengdu.b41c4de1.png";